import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';

import styles from './styles.module.scss';
import '../../style.scss';
//-----
import { HighlightCard } from '../HighlightCard';
import { useCarousel } from '../../../ContentsCarouselDreams/hooks/useCarousel';
import Controls from '../../../ContentsCarouselDreams/components/Controls';
import { useScrollHorizontalInfiniteCarouse } from '../../../ContentsCarouselDreams/hooks/useScrollHorizontalInfiniteCarouse';
import { selectMetadataKeyByRegion } from 'reducers/selectors/metadata';
import {
  debounceFunction,
  getSlidePercentage,
} from 'containers/CarouselsDisplay/utils/carouselsUtils';
import { ReloadCarouselButton } from '../../../ReloadCarouselButton';
import { useVerifyIsMobile } from 'hooks/useVerifyIsMobile';
import { useTouchScroll } from '../../../ContentsCarouselDreams/hooks/useTouchScroll';

export const HighlightCarouselNew = ({
  contentsList,
  name,
  isMobile,
  hasError,
  handleReload,
  autoplay = true,
}) => {
  const breakPoinMaxSizeDesktop = 2334;
  const { isMobile: sizeMax } = useVerifyIsMobile(breakPoinMaxSizeDesktop);
  const { isMobile: showChvron } = useVerifyIsMobile(768);
  const superHighlightRef = useRef([])
  const idCard = useRef(null);

  const wrapperScrollRef = useRef(null);
  const idInterval = useRef(null);
  const valueTranslateXInit = useRef(null);
  const valueTranslateXNext = useRef(null);
  const IsSizeMaxDesktop = useRef(null);

  IsSizeMaxDesktop.current = sizeMax;

  const numbersCardEffectException = () => {
    if (contentsList?.length == 1) {
      return [...contentsList, ...contentsList, ...contentsList];
    }
    if (contentsList?.length == 2) {
      return [...contentsList, ...contentsList];
    }
    return contentsList;
  };

  const newContentsList = numbersCardEffectException();

  const {
    trackRef,
    canDoCarousel,
    handleNextSuper,
    handlePrevSuper,
  } = useCarousel(newContentsList);

  const [slidePercentege, setSlidePercentege] = useState(
    getSlidePercentage(isMobile),
  );

  const debounce = debounceFunction(() => {
    const resizeMovil = getSlidePercentage(isMobile);
    setSlidePercentege(resizeMovil);
  }, 200);

  const positionSlide = (index = 1, centerSlidePercentage) => {
    let currentPosition = -index * centerSlidePercentage;
    currentPosition += (100 - centerSlidePercentage) / 2;
    if (!IsSizeMaxDesktop.current) {
      // aqui el tamaño del screen es demasiado grando y distorciona el efecto de la translateX, por eso se agrega esta regla para corregirlo
      currentPosition = currentPosition / (newContentsList?.length * 48);
    }
    return currentPosition;
  };

  valueTranslateXInit.current = positionSlide(1, slidePercentege);

  const getValuerTranslateNext = () => {
    const slidePercentegeNumbe = Math.abs(Number(slidePercentege));
    const valueTranslateXInitNumber = Math.abs(
      Number(valueTranslateXInit.current),
    );
    return slidePercentegeNumbe + valueTranslateXInitNumber;
  };

  valueTranslateXNext.current = getValuerTranslateNext();

  const autoplayTime = useSelector(
    selectMetadataKeyByRegion('superhiglight_auto_move_time'),
  );
  const delayInterval =
    autoplayTime?.time === 'number' ? autoplayTime?.time * 1000 : 5000;

  const startAutoPlay = () => {
    if (!autoplay) return;

    if (!idInterval?.current) {
      idInterval.current = setInterval(() => {
        handleNextSuper(
          valueTranslateXInit.current,
          valueTranslateXNext.current,
          !IsSizeMaxDesktop.current,
        );
      }, delayInterval);
    }
  };

  const stopAutoplay = () => {
    clearInterval(idInterval.current);
    idInterval.current = null;
  };

  const handleNextMiddleware = () => {
    stopAutoplay();
    handleNextSuper(
      valueTranslateXInit.current,
      valueTranslateXNext.current,
      !IsSizeMaxDesktop.current,
    );
    startAutoPlay();
  };

  const handlePrevMiddleware = () => {
    stopAutoplay();
    handlePrevSuper(
      valueTranslateXInit.current,
      valueTranslateXNext.current,
      !IsSizeMaxDesktop.current,
    );
    startAutoPlay();
  };

  useEffect(
    () => {
      window.addEventListener('resize', debounce);
      setSlidePercentege(getSlidePercentage(isMobile));
      return () => window.removeEventListener('resize', debounce);
    },
    [isMobile],
  );

  useEffect(() => {
    autoplay && startAutoPlay();
    return () => {
      stopAutoplay();
    };
  }, []);

  const setIdCardRef = (id) => {
    idCard.current = id;
  }

  //useScrollHorizontalInfiniteCarouse(wrapperScrollRef,trackRef)
  useTouchScroll(
    wrapperScrollRef,
    handleNextMiddleware,
    handlePrevMiddleware,
    stopAutoplay,
    startAutoPlay,
    superHighlightRef,
    idCard,
  );

  return (
    <>
      {hasError ? (
        <ReloadCarouselButton handleReload={handleReload} />
      ) : (
        <div className={styles.carruselHighlightCarouselNew}>
          <Controls
            title={''}
            name={''}
            handleNextSlide={handleNextMiddleware}
            handlePrevSlide={handlePrevMiddleware}
            showControls={hasError ? !hasError : canDoCarousel}
            stylesHeader={{
              marginTop: '0px',
              marginBottom: `${isMobile ? '0px' : '16px'}`,
            }}
            stylesNavigation={{ display: `${showChvron ? 'none' : 'flex'}` }}
          />
          <div
            className={styles.highlightCarouselNew}
            ref={wrapperScrollRef}
            onMouseOver={stopAutoplay}
            onMouseOut={startAutoPlay}
          >
            <ul
              className={styles.highlightCarouselNew_wrapper}
              ref={trackRef}
              style={{
                transform: `translateX(${valueTranslateXInit.current}%)`,
                // justifyContent: `${contentsList?.length  < 2 ? 'center' : ' flex-start' }`
              }}
            >
              {newContentsList &&
                newContentsList?.map((content, index) => (
                  <li
                    key={`${content.id}${index}`}
                    className={styles.wrapper_item}
                    style={{
                      width: `${slidePercentege}%`,
                      minWidth: `${slidePercentege}%`,
                      paddingLeft: `${isMobile ? '4px' : '12px'}`,
                      paddingRight: `${isMobile ? '4px' : '12px'}`,
                    }}
                  >
                    <HighlightCard
                      contentInfo={content}
                      isMobile={isMobile}
                      carouselTitle={name}
                      contentPosition={index}
                      ref={(el) => (superHighlightRef.current[content?.url] = el)}
                      setIdCardRef={setIdCardRef}
                    />
                  </li>
                ))}
            </ul>
          </div>
        </div>
      )}
    </>
  );
};
